import { useMutation } from "react-query";
import { deleteSocialHistory } from "api/customers";
import { useGlobalToast } from "components/GlobalToastProvider";

export const useDeleteSocialHistory = (options: Record<string, any> = {}) => {
  const { onError = () => {}, ...otherOptions } = options;
  const { showToast } = useGlobalToast();

  const { mutate, isLoading, ...rest } = useMutation(
    (id: number) => deleteSocialHistory(id),
    {
      onError: () => {
        showToast({
          message: "Whoops! Something went wrong while deleting the social history.",
          errorState: true,
        });
        onError();
      },
      ...otherOptions,
    }
  );

  return {
    deleteSocialHistoryMutation: mutate,
    isDeleteSocialHistoryLoading: isLoading,
    ...rest,
  };
};

export default useDeleteSocialHistory;
